<template>
  <div class="campaign-list">
    <div class="campaign-list__aside">
      <el-menu
        class="campaign-side-menu"
        :default-active="activeKey"
        background-color="#F5F7FA"
        text-color="#303133"
        active-text-color="#FFFFFF"
        :unique-opened="true"
        @select="onSelect"
      >
        <el-menu-item v-for="item in menuList" :key="item.key" :index="item.key">{{ item.label }}</el-menu-item>
      </el-menu>
    </div>
    <div class="campaign-list__main">
      <component :is="componentMap[activeKey]" />
    </div>
  </div>
</template>

<script>
import Combo from './campaignPages/combo.vue'

export default {
  name: 'campaignList',
  components: { Combo },
  data() {
    return {
      activeKey: 'combo',
      menuList: [
        { key: 'combo', label: '套餐/任选活动' }
      ],
      componentMap: {
        combo: Combo
      }
    }
  },
  methods: {
    onSelect(key) {
      this.activeKey = key
    }
  }
}
</script>

<style lang="less" scoped>
.campaign-list {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  width: 100%;
  height: 100%;
  background: #fff;
  overflow: hidden;
}

.campaign-list__aside {
  flex-shrink: 0;
  box-sizing: border-box;
  width: 200px;
  padding: 20px 12px;
  background-color: #FAFBFC;
  border-right: 1px solid #E0E0E0;
  overflow-x: hidden;
  overflow-y: auto;
}

.campaign-side-menu {
  box-sizing: border-box;
  border-right: none;
}

.campaign-side-menu /deep/ .el-menu-item {
  box-sizing: border-box;
  padding: 0 8px !important;
  width: 100%;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  color: #303133;
  border: none;
  border-radius: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: background-color 0.2s, color 0.2s;
}

.campaign-side-menu /deep/ .el-menu-item + .el-menu-item {
  margin: 8px 0 0 0;
}

.campaign-side-menu /deep/ .el-menu-item:hover {
  background-color: #ecf5ff !important;
  color: #1890FF !important;
}

.campaign-side-menu /deep/ .el-menu-item.is-active {
  background-color: #1890FF !important;
  color: #fff !important;
}

.campaign-side-menu /deep/ .el-menu-item.is-active:hover {
  background-color: #1890FF !important;
  color: #fff !important;
}

.campaign-list__main {
  flex: 1;
  min-width: 0;
  height: 100%;
  background: #FFFFFF;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
